// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w0-z","displaySixCardTiles":"x0-z"};